export default __webpack_public_path__ + "static/media/agile-alt-lockup.255a5ba5.svg";